var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextSectionWrapper = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

exports.TextSectionWrapper = function (props) {
  var ContainerType = props.containerStyle === 'container' ? core_1.Container : core_1.Fluid;
  return react_1.default.createElement(core_1.Wrapper, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.wrapper
    })
  }, react_1.default.createElement(ContainerType, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.container
    })
  }, props.children));
};